import { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables';
import cn from 'classnames';
import appConfig from 'src/appConfig';
// import CustomSearchRender from 'src/components/CustomSearchRender';
import _ from 'lodash';
import { GetTimesheetsParams } from 'src/redux/timesheet/types';
import { isEmpty } from 'src/validations';

export const getColumns = (isAll: boolean = false, trades: any[], levels: any[]) => {
  let columns: MUIDataTableColumn[] = [];
  if (isAll) {
    columns.push({
      name: 'startDate',
      label: 'Time Period',
      options: {
        filter: false,
        sort: true,
      },
    });
  }
  columns.push(
    { name: 'employeeId', label: 'Employee ID', options: { filter: false, sort: true } },
    {
      name: 'employeeLastName',
      label: 'Employee Name',
      options: {
        filter: false,
        sort: true,
      },
    },
  );

  if (isAll) {
    columns.push({
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          names: ['Submitted', 'Open'],
        },
        customBodyRender: (value: string) => {
          return <p className={cn({ 'active-status': value === 'submitted' })}>{_.capitalize(value)}</p>;
        },
      },
    });
  }
  columns.push(
    {
      name: 'trade',
      label: 'Trade',
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          names: trades.map(item => item.label),
        },
      },
    },
    {
      name: 'level',
      label: 'Level',
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          names: levels.map(item => item.label),
        },
      },
    },
  );
  if (isAll) {
    columns.push(
      {
        name: 'rate',
        label: 'Rate',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value: number) => {
            return Number(value).toFixed(2);
          },
        },
      },
      {
        name: 'regularHours',
        label: 'Regular Hours',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'overtimeHours',
        label: 'OT Hours',
        options: {
          filter: false,
          sort: true,
        },
      },
    );
  } else {
    columns.push({
      name: 'totalHours',
      label: 'Total Hours',
      options: {
        filter: false,
        sort: true,
      },
    });
  }
  return columns;
};
export const getOptions = (
  isAll: boolean = false,
  totalTimesheet: number = 0,
  handleRowClick,
  handleDownload,
  take?: number,
) => {
  const tableOptions: MUIDataTableOptions = {
    rowsPerPageOptions: appConfig.ROWS_PER_PAGE_OPTIONS,
    count: totalTimesheet,
    download: isAll,
    onRowClick: handleRowClick,
    onDownload: (buildHead, buildBody, columns, data) => {
      handleDownload(); // this makes a REST call to the server and downloads the data
      return false;
    },
    rowsPerPage: take,
    searchPlaceholder: 'Search by employee ID or employee name',
    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //   return (
    //     <CustomSearchRender
    //       placeholder={'Search by employee ID or employee name'}
    //       searchText={searchText}
    //       onSearch={handleSearch}
    //       onHide={hideSearch}
    //       options={options}
    //     />
    //   );
    // },
  };

  return tableOptions;
};
export const TabIdx = {
  All: 0,
  Week: 1,
};

export const TimesheetTabs = [
  { index: TabIdx.All, label: 'All Timesheets' },
  { index: TabIdx.Week, label: 'Weekly Timesheets' },
];
export const filterTimesheet = (params: GetTimesheetsParams) => {
  let res = { ...params };
  Object.keys(res).forEach(key => {
    if (isEmpty(res[key])) delete res[key];
    if (key === 'status') {
      res['status'] = res.status[0].toLowerCase();
    }
  });
  return res;
};
